(function(){
'use strict';
if(window.DaLucaModalCloseFix)return;window.DaLucaModalCloseFix=true;
function unlock(){
  document.documentElement.classList.remove('daluca-universal-viewer-open','daluca-custom-lightbox-v9-open','daluca-visualizer-modal-open');
  document.body.classList.remove('daluca-universal-viewer-open','daluca-custom-lightbox-v9-open');
}
function hide(el){if(!el)return;el.classList.remove('is-open','is-visible','open','active');el.setAttribute&&el.setAttribute('aria-hidden','true');}
function closeVisualizer(el){
  var root=el.closest('[data-daluca-visualizer]');
  if(root){root.dispatchEvent(new CustomEvent('daluca:visualizer-close'));}
  var opener=root&&root.querySelector('[data-daluca-open-modal]');
  var copy=el.querySelector('[data-daluca-modal-copy]');
  if(copy)window.DaLucaI18n.setText(copy, '');
  el.hidden=true;
  if(opener&&opener.isConnected)opener.focus({preventScroll:true});
}
document.addEventListener('click',function(e){
  var t=e.target;if(!t||!t.closest)return;
  var close=t.closest('[data-dluv-close],.daluca-universal-image-viewer__close,.daluca-option-lightbox__close,.daluca-option-lightbox-v35 button[aria-label*="Close" i],[data-dlv9-close],.daluca-custom-lightbox-v9__close,[data-dl-close],.daluca-pdp-lightbox__close,[data-daluca-close-modal],.daluca-visualizer__modal-close');
  if(!close)return;
  var handled=false;
  var viewer=close.closest('.daluca-universal-image-viewer');if(viewer){hide(viewer);handled=true;}
  var option35=close.closest('.daluca-option-lightbox-v35');if(option35){hide(option35);handled=true;}
  var optionOld=close.closest('.daluca-option-lightbox');if(optionOld){hide(optionOld);handled=true;}
  var custom=close.closest('.daluca-custom-lightbox-v9');if(custom){hide(custom);handled=true;}
  var ready=close.closest('.daluca-pdp-lightbox');if(ready){hide(ready);handled=true;}
  var vis=close.closest('.daluca-visualizer__modal');if(vis){closeVisualizer(vis);handled=true;}
  if(handled){e.preventDefault();e.stopPropagation();unlock();}
},true);
document.addEventListener('keydown',function(e){if(e.key!=='Escape')return;document.querySelectorAll('.daluca-universal-image-viewer.is-open,.daluca-option-lightbox-v35.is-visible,.daluca-option-lightbox.is-visible,.daluca-custom-lightbox-v9.is-open,.daluca-pdp-lightbox.is-open,.daluca-visualizer__modal:not([hidden])').forEach(function(el){if(el.classList.contains('daluca-visualizer__modal'))closeVisualizer(el);else hide(el)});unlock();},true);
})();

